(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const updateLogo = (footer) => {
    const logoStage = footer.querySelector('[data-footer-logo]');
    const logo = logoStage?.querySelector('.site-footer__logo');
    if (!logo || !logoStage) return;

    if (reducedMotion.matches) {
      logo.style.removeProperty('--footer-logo-opacity');
      logo.style.removeProperty('--footer-logo-rotate-x');
      logo.style.removeProperty('--footer-logo-translate-y');
      return;
    }

    const logoStageTop = logoStage.getBoundingClientRect().top + scrollY;
    const progress = Math.min(1, Math.max(0, (scrollY + innerHeight - logoStageTop) / logoStage.offsetHeight));
    const remaining = 1 - progress;

    logo.style.setProperty('--footer-logo-opacity', progress.toFixed(3));
    logo.style.setProperty('--footer-logo-rotate-x', `${remaining * 65}deg`);
    logo.style.setProperty('--footer-logo-translate-y', `${remaining * 110}%`);
  };

  const init = (footer) => {
    if (footer.dataset.initialized) return;
    updateLogo(footer);

    if (!('IntersectionObserver' in window) || reducedMotion.matches) {
      footer.classList.add('is-visible');
      footer.dataset.initialized = 'true';
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      footer.classList.add('is-visible');
      observer.disconnect();
    }, { threshold: 0.08 });

    observer.observe(footer);
    footer.dataset.initialized = 'true';
  };

  const initAll = (root = document) => root.querySelectorAll?.('[data-site-footer]').forEach(init);
  let frame;

  const updateAllLogos = () => {
    frame = null;
    document.querySelectorAll('[data-site-footer]').forEach(updateLogo);
  };

  const requestLogoUpdate = () => {
    if (!frame) frame = requestAnimationFrame(updateAllLogos);
  };

  initAll();

  if (!window.unfoundFooterEventsBound) {
    window.unfoundFooterEventsBound = true;
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    addEventListener('scroll', requestLogoUpdate, { passive: true });
    addEventListener('resize', requestLogoUpdate);
    reducedMotion.addEventListener('change', requestLogoUpdate);
  }
})();
